import { util, shapes } from '@clientio/rappid';
import { SelectOptionAttributes } from './selectOption.attributes';

export class SelectOptionShape extends shapes.standard.Rectangle {
  defaults(): object {
    return util.defaultsDeep(SelectOptionAttributes, shapes.standard.Rectangle.prototype.defaults);
  }
}
